export const msgTypes = {
  APP_ID:       "APP315796524644",
  SALT_ID:      "9f6fc8c7775c4c42",

  // Used exclusively for payReq encryption
  CHECKOUT_ID:  "2026CheckoutId",
  CHECKOUT_KEY: "keY2026Checkout",

  // Used exclusively for order-link generation (OrderGenerateRequest)
  ORDER_LINK_APP_ID:     "UATAPP22F05M26D110840A",
  ORDER_LINK_SECRET_KEY: "59cfb65f1dcc4f7b",

  // APP_ID: "APP752089274926",
  // SALT_ID: "2fe9b5395c714eef",

  USERNAME: "user@green.com",
  PASSWORD: "Test@123",

  KEY_LENGTH: 256, // Key length in bits
  ITERATION_COUNT: 65536, // Iteration count for PBKDF2
  UPI: {
    INTENT:  "INTENT",
    COLLECT: "COLLECT",
    QR:      "QR",
    SQR:     "SQR",    // Static QR
  },

  PAYMENT_METHOD: {
    QR: "QR",
    UPI: "UPI",
    CARD: "CARD",
    NETBANKING: "NETBANKING",
    WALLET: "WALLET",
  },

  PAYMENT_TYPE: {
    UP: "UP",
    WL: "WL",
    CD: "CD",
    NB: "NB",
  },

  SUCCESS_CODE: [200],

  SUCCESS: "SUCCESS",
  PENDING: "SENTTOBANK",
  CANCELLED: "CANCELLED",
  FAILED: "FAILED",
};
